import VForm from '@/vuetify_custom/v-form'
import VModel from '@/vuetify_custom/v-modal_v1'
import {postPlacingAdsKolSaveApi} from '@/views/blogger/resourcelibrary/service.js'
function createParams() {
    return {
        fans_amount:null,
        id:null,
    }
}
export default {
    data() {
        return {
            dis: false,
            submitLoading: false,
            params:createParams(),
    
        }
    },
    computed: {
        baseInforFields() {
            const d = [(val) => !!val || '必填']
            const arr = [
                {
                    label: '粉丝数量',
                    key:'fans_amount',
                    type: 'integer_field',
                    cols: 8,
                    required: true,
                    rules: [...d, (v) => v >= 0 || '不能为负数！']
                },
                
              
            ]
            return arr
        },
    },
    created() {
     
    },
    methods: {
   
      
        edit(params) {
            this.dis = true
            this.params = createParams()
            if (params) {
                const clone_params = this.params
                Object.keys(clone_params).forEach(key => {
                    clone_params[key] = params[key]
                })
               //  clone_params.tags = clone_params.tags.split(',')
                this.params = clone_params
            }
        },
        submit() {
            if (!(this.$refs.base && this.$refs.base.validate && this.$refs.base.validate())) {
                return
            }
            this.submitLoading = true
          
            
            postPlacingAdsKolSaveApi(this.params).then(() => {
                this.$emit('success')
                this.dis = false
                this.$Message.success('保存成功！')
            }).finally(() => {
                this.submitLoading = false
            })
        }
    },
    render() {
        return <VModel
        v-model={this.dis}
        persistent
       
        title="更新博主粉丝数"
        max-width="600"
        loading={this.submitLoading}
        on={{
             ok: this.submit,
            // cancel: _this.cancel
        }}
       
    >
        <VForm
            ref="base"
            v-model={this.params}
            fields={this.baseInforFields}
        />
        </VModel>
    }
}